/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-service-pool-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleNew = `${prefix}.modalTitleNew`;
export const enableGslbServicePoolCheckboxLabel = `${prefix}.enableGslbServicePoolCheckboxLabel`;
export const priorityInputPlaceholder = `${prefix}.priorityInputPlaceholder`;
export const minHealthMonitorsUpInputLabel = `${prefix}.minHealthMonitorsUpInputLabel`;
export const minHealthMonitorsUpInputPlaceholder = `${prefix}.minHealthMonitorsUpInputPlaceholder`;
export const loadBalancingAlgorithmDropdownLabel = `${prefix}.loadBalancingAlgorithmDropdownLabel`;
export const enableManualResumeCheckboxLabel = `${prefix}.enableManualResumeCheckboxLabel`;
export const fallbackAlgorithmSelectionLabel = `${prefix}.fallbackAlgorithmSelectionLabel`;
export const consistentHashMaskInputLabel = `${prefix}.consistentHashMaskInputLabel`;
export const consistentHashMaskInputPlaceholder = `${prefix}.consistentHashMaskInputPlaceholder`;
export const consistentHashMaskV6InputLabel = `${prefix}.consistentHashMaskV6InputLabel`;
export const consistentHashMaskV6InputPlaceholder = `${prefix}.consistentHashMaskV6InputPlaceholder`;
export const poolMemberSectionHeader = `${prefix}.poolMemberSectionHeader`;
export const changingPoolTypeWarning = `${prefix}.changingPoolTypeWarning`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit GSLB Pool',
    [modalTitleNew]: 'Create GSLB Pool',
    [enableGslbServicePoolCheckboxLabel]: 'Enable GSLB Pool',
    [priorityInputPlaceholder]: 'Enter Priority',
    [minHealthMonitorsUpInputLabel]: 'Min Health Monitors to consider server \'up\'',
    [minHealthMonitorsUpInputPlaceholder]: 'Enter Min Health Monitors',
    [loadBalancingAlgorithmDropdownLabel]: 'Pool Members Load Balancing Algorithm',
    [enableManualResumeCheckboxLabel]: 'Enable Manual Resume',
    [fallbackAlgorithmSelectionLabel]: 'Fallback Algorithm',
    [consistentHashMaskInputLabel]: 'Consistent Hash Mask for IPv4',
    [consistentHashMaskInputPlaceholder]: 'Enter Consistent Hash Mask for IPv4',
    [poolMemberSectionHeader]: 'Pool Member',
    [consistentHashMaskV6InputLabel]: 'Consistent Hash Mask for IPv6',
    [consistentHashMaskV6InputPlaceholder]: 'Enter Consistent Hash Mask for IPv6',
    [changingPoolTypeWarning]: 'Changing the GSLB Pool type will remove Public IPs configured in the pool members.',
};
